import collapse from '@alpinejs/collapse';
import intersect from "@alpinejs/intersect";
import persist from "@alpinejs/persist";
import resize from "@alpinejs/resize";

import swiper from './swiper';
import jumboText from './jumbo-text';
import marquee from './marquee';
import countdown from './countdown';
import typewriter from './typewriter';

export default (Alpine) => {
  Alpine.plugin(collapse);
  Alpine.plugin(intersect);
  Alpine.plugin(persist);
  Alpine.plugin(resize);

  Alpine.plugin(swiper);
  Alpine.plugin(jumboText);
  Alpine.plugin(marquee);
  Alpine.plugin(countdown);
  Alpine.plugin(typewriter);
};
